import { createRouter, createMemoryHistory } from 'vue-router';

const routes = [
    {
        path: '/',
        redirect: '/home'
    }, {
        path: '/home',
        name: 'home',
        component: () => import('../views/homePage.vue')
    }, {
        path: '/service',
        name: 'loanService',
        component: () => import('../views/loanService.vue')
    }, {
        path: '/about',
        name: 'aboutUS',
        component: () => import('../views/aboutUS.vue')
    }, {
        path: '/contact',
        name: 'contactUS',
        component: () => import('../views/contactUS.vue')
    }, {
        path: '/privatePolicy_Zayra',
        name: 'privatePolicy_Zayra',
        component: () => import('../views/privatePolicy_Zayra.vue')
    }, {
        path: '/loanAgreement_Zayra',
        name: 'loanAgreement_Zayra',
        component: () => import('../views/loanAgreement_Zayra.vue')
    }, {
        path: '/lending',
        name: 'lendingPartner',
        component: () => import('../views/LendingPartner.vue')
    }, {
        path: '/privatePolicy_NidhiNow',
        name: 'privatePolicy_NidhiNow',
        component: () => import('../views/privatePolicy_NidhiNow.vue')
    }, {
        path: '/loanAgreement_NidhiNow',
        name: 'loanAgreement_NidhiNow',
        component: () => import('../views/loanAgreement_NidhiNow.vue')
    },

]

const router = createRouter({
    history: createMemoryHistory(),
    routes
})

export default router;
